// extracted by mini-css-extract-plugin
export default {"thank-you":"CartSuccess_thank-you__wuF0l","fade-in":"CartSuccess_fade-in__wz3ZH","dropdown":"CartSuccess_dropdown__Ek6BR"};